export default {
  back: "Volver",
  error: "Error",
  votes: "Votaciones",
  blockchain: "Blockchain",
  logout: "Cerrar sesión",
  logoutConfirmTitle: "¿Cerrar sesión?",
  logoutConfirmMessage: "Se cerrará tu sesión actual y volverás al inicio.",
  confirm: "Confirmar",
  view: "Ver",
  loading: "Cargando...",
  cancel: "Cancelar",
  save: "Guardar",
  close: "Cerrar",
}
